import React, { useState } from "react";
import { useLoad } from "../../../components/Common/useLoading";
import { getVisitsTracking, getVisitsTrackingTimeLineAPI } from "../../../api/protocol";

export default function useVisitsTracking({ mapping = (visit) => visit } = {}) {
    const [visits, setVisits] = useState([]);
    const [isLoading, working] = useLoad();

    const actions = {
        search: async (protocolId, patientNumberInProtocol) => await working(async () => {
            if (!protocolId || !patientNumberInProtocol) {
                setVisits([]);
                return;
            }

            const response = await getVisitsTrackingTimeLineAPI(protocolId, patientNumberInProtocol) //await getVisitsTracking(protocolId, { filters: { medicalRecordNumber: patientNumberInProtocol } });

            const mappedVisits = response.data.map(mapping);
            setVisits(mappedVisits);
        }),
        clear: () => {
            setVisits([]);
        }
    }


    return [visits, isLoading, actions]
}